var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.933 2.23197L10.04 7.37497C9.477 7.86697 8.752 8.13797 7.999 8.13797C7.246 8.13797 6.522 7.86697 5.959 7.37597L0.066 2.23097C0.051 2.21797 0.0390001 2.20197 0.0250001 2.18797C0.0150001 2.27297 0 2.35697 0 2.44397V9.55497C0 10.78 0.997 11.777 2.222 11.777H13.777C15.002 11.777 15.999 10.78 15.999 9.55497V2.44397C15.999 2.35597 15.984 2.27197 15.974 2.18597C15.961 2.20097 15.948 2.21797 15.933 2.23197Z",
    fill: "#BEEB9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.389 0.929985C14.984 0.479985 14.398 0.221985 13.778 0.221985H2.223C1.603 0.221985 1.017 0.479985 0.611999 0.929985C0.532999 1.01898 0.492 1.13398 0.499 1.25398C0.506 1.37198 0.56 1.48298 0.65 1.56098L6.544 6.70599C6.959 7.06799 7.48 7.24898 8 7.24898C8.52 7.24898 9.041 7.06799 9.456 6.70599L15.35 1.56198C15.44 1.48398 15.495 1.37398 15.501 1.25398C15.509 1.13398 15.468 1.01898 15.389 0.929985Z",
    fill: "#BEEB9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.ece0bb0de23cf1a3508af606eeb1ccd5.svg";
export { ForwardRef as ReactComponent };